import { render, staticRenderFns } from "./WalletConnectFull.vue?vue&type=template&id=ec1e7bd4&scoped=true&"
import script from "./WalletConnectFull.vue?vue&type=script&lang=js&"
export * from "./WalletConnectFull.vue?vue&type=script&lang=js&"
import style0 from "./WalletConnectFull.vue?vue&type=style&index=0&id=ec1e7bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1e7bd4",
  null
  
)

export default component.exports